// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"98":"7055f09f","216":"5bf9fe73","315":"baa4b1e7","380":"4bed253c","777":"f60a63f3","783":"14b3f302"}[chunkId] + ".chunk.js";
};